var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('w-alert',{staticClass:"margin-top-30",attrs:{"closable":false,"level":"warning","message":_vm.message}})}
var staticRenderFns = []

export { render, staticRenderFns }